/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { routes } from 'const';
import { CheckIcon } from 'components/elements/Icons';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AccountActivationSuccess() {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  return (
    <>
      <div className={classes.correctEmailText}>
        <Typography style={{ fontWeight: 'bold' }} className={classes.caption} variant="h6" component="h6">
          {t('your_account_has_been_activated_successfully')}
        </Typography>
      </div>
      <CheckIcon classes={classes.checkMark} />
      <Link className={classes.loginLink} to={routes.login}>
        {t('login_here')}
      </Link>
    </>
  );
}

export default AccountActivationSuccess;
